export const redirectTo = url => {
  let initialWindow = window

  while (initialWindow.self !== window.top) {
    initialWindow = window.top
  }
  initialWindow.location.replace(url)
}
